import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";

const createPaypalOrderCallable = httpsCallable<{ credits: number; companyId: string }, any>(functions, "createPaypalOrder");
const capturePaypalPaymentCallable = httpsCallable<
  { orderId: string; companyId: string },
  any
>(functions, "capturePaypalPayment");

export const createPaypalOrder = async (credits: number, companyId: string): Promise<any> => {
  const request = { credits, companyId };
  const res = await createPaypalOrderCallable(request);
  return res.data;
};

export const capturePaypalPayment = async (orderId: string, companyId: string): Promise<any> => {
  const res = await capturePaypalPaymentCallable({ orderId, companyId });
  return res.data;
};
